export function getdata() {
	let obj = {
		headData: [{
				title: '纳税人识别号',
				prop: 'identificationCode',
				width: '180',
				issort: true,
				align: "left",
			}, {
				title: '公司名称',
				prop: 'companyName',
				width: '180',
				issort: true,
				align: "left",
			},
			{
				title: '公司代码',
				prop: 'companyCode',
				width: '160',
				issort: true,
				align: "right",
			},
			{
				title: '剩余可用授信额度',
				prop: 'remainingAvailableCodeCount',
				width: '160',
				issort: true,
				custom: true,
				align: "right",
				AmountFormat: true
			}, {
				title: '已下载未使用授信额度',
				prop: 'residualLimit',
				width: '180',
				issort: true,
				custom: true,
				align: "right",
				AmountFormat: true
			}, {
				title: '剩余可用预赋码数量',
				prop: 'unusedQuotaHasBeenDownloaded',
				width: '160',
				issort: true,
				custom: true,
				align: "right",
				AmountFormat: true
			},
			{
				title: '蓝字发票不含税金额合计',
				prop: 'blueInvoiceAmount',
				width: '180',
				issort: true,
				custom: true,
				align: "right",
				AmountFormat: true
			},
			{
				title: '蓝字发票累计税额',
				prop: 'blueInvoiceTaxAmount',
				width: '160',
				issort: true,
				custom: true,
				align: "right",
				AmountFormat: true
			},
			{
				title: '红字发票不含税金额合计',
				prop: 'redInvoiceAmount',
				width: '180',
				issort: true,
				custom: true,
				align: "right",
				AmountFormat: true
			}, {
				title: '红字发票累计税额',
				prop: 'redInvoiceTaxAmount',
				width: '160',
				issort: true,
				custom: true,
				align: "right",
				AmountFormat: true
			},
		],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}